import React from "react";
import FavoriteButton from "../../../../containers/FavoriteButton";
import styles from "./adSummaryBottom.scss";
import { Icon } from "antd";

export interface AdSummaryBottomProps {
  ad: any;
  adLists: any;
  hasFavorite: boolean;
  handleNote?: Function;
  className: string;
  category: string;
}

export interface FavoriteButtonWrapperProps {
  ad: any;
  children: any;
  handleFavorite: Function;
  handleNote?: Function;
}

const FavoriteButtonWrapper = (props: FavoriteButtonWrapperProps) => {
  const { ad, children, handleFavorite } = props;

  return (
    <span
      className={
        ad && ad.isFavorite
          ? styles.bottomButtonContainerFavorite
          : styles.bottomButtonContainerNotFavorite
      }
      onClick={handleFavorite}
    >
      {children}
    </span>
  );
};

const AdSummaryBottom = (props: AdSummaryBottomProps) => {
  const { ad, adLists, hasFavorite, className, category, handleNote } = props;
  return (
    <div className={`${styles.postedTimeContainer} ${className}`}>
      <span className={styles.postedTime}>{ad.postedTime}</span>
      <div>
        {(handleNote && !ad.note) && (
          <span className={styles.bottomButtonContainerNote} onClick={(e) => handleNote(e, ad)}>
            <span className={styles.notesText}>Bilješka</span>
            <Icon type="edit" className={styles.notesIcon} />
          </span>
        )}
        {hasFavorite && (
          <FavoriteButton
            adLists={adLists}
            ad={ad}
            className={styles.bottomButton}
            category={category}
            wrapper={FavoriteButtonWrapper}
          />
        )}
      </div>
    </div>
  );
};

AdSummaryBottom.defaultProps = {
  hasFavorite: false,
  handleNote: false,
  className: ""
};

export default AdSummaryBottom;



// WEBPACK FOOTER //
// ./src/components/AdCard/AdSummary/AdSummaryBottom/AdSummaryBottom.tsx